"use client"

import { useState, useEffect } from "react"
import { Box } from "@chakra-ui/react"
import { Footer } from "../../features/footer/footer"
import Navigation from "./components/navigation"
import HeroSection from "./components/hero-section"
import BenefitsSection from "./components/benefits-section"
import StepsSection from "./components/steps-section"
import FeaturedEmployers from "./components/featured-employers"
import ServicesSection from "./components/services-section"
import TestimonialsSection from "./components/testimonials-section"
import FAQSection from "./components/faq-section"
import CTASection from "./components/cta-section"
import LoadingScreen from "./components/loading-screen"
import "./animations.css"

const EmployerHome = () => {
  const [scrolled, setScrolled] = useState(false)
  const [isPageLoaded, setIsPageLoaded] = useState(false)

  // Simulate page loading
  useEffect(() => {
    setTimeout(() => {
      setIsPageLoaded(true)
    }, 1000)
  }, [])

  // Handle scroll event for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  // Loading overlay
  if (!isPageLoaded) {
    return <LoadingScreen />
  }

  return (
    <Box className="overflow-hidden">
      {/* Navigation Bar */}
      <Navigation scrolled={scrolled} />

      {/* Hero Section */}
      <HeroSection />

      {/* Benefits Section */}
      <BenefitsSection />

      {/* Steps Section */}
      <StepsSection />

      {/* Featured Employers Section */}
      <FeaturedEmployers />

      {/* Services Section */}
      <ServicesSection />

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* FAQs Section */}
      <FAQSection />

      {/* CTA Section */}
      <CTASection />

      {/* Footer */}
      <Box as="footer" color="gray.400">
        <Footer />
      </Box>
    </Box>
  )
}

export default EmployerHome
